import { useTheme } from '@mui/material/styles';
import { CheckCircleOutline } from '@mui/icons-material';
import { formatToAmount } from '@qrios/frontend-library';

import locales from '../../../../../../../constants/locales';
import DetailsList from '../../../../../../common/details-list';
import { detailsValueFormatter } from '../../../../../../../utils/details';
import DetailsFactory from '../../../../../../common/details-list/detailsFactory';

import { getBankName } from './helpers';
import { OperationSuccess } from './interfaces';

interface Props {
  operation: OperationSuccess;
}

const SuccessOperation = ({ operation }: Props) => {
  const theme = useTheme();
  const { details, senderMsisdn, transferAmount, cost } = operation;

  return (
    <DetailsFactory
      header={{
        icon: { component: CheckCircleOutline, color: theme.palette.success.main },
        id: operation.id,
        date: operation.date,
        status: operation.status
      }}
      operationContent={
        <DetailsList
          items={[
            {
              label: locales.operation.label.senderMsisdn,
              value: detailsValueFormatter(senderMsisdn)
            },
            { label: locales.operation.label.debitBank, value: getBankName(details.debitAccount) },
            { label: locales.operation.label.senderEmail, value: details.senderEmail },
            { label: locales.operation.label.debitAccountNumber, value: details.debitAccount.accountNumber },
            { label: locales.operation.label.transferAmount, value: formatToAmount(transferAmount.value) },
            { label: locales.operation.label.creditBank, value: getBankName(details.creditAccount) },
            { label: locales.operation.label.cost, value: formatToAmount(cost.value) },
            { label: locales.operation.label.creditAccountNumber, value: details.creditAccount.accountNumber }
          ]}
        />
      }
    />
  );
};

export default SuccessOperation;
